@let activeCurrency = currency() ?? summary()?.currency;
@let activeSummary = summary();
@let isCardLoading = isLoading() || !activeCurrency;

<div class="row g-3 mb-4">
    <!-- Succeeded payments -->
    <div class="col-12 col-xl-6">
        <div class="card h-100 stat-card">
            <div class="card-body d-flex align-items-center gap-2 gap-md-3 p-3 p-md-4">
                <div class="rounded-circle d-flex align-items-center justify-content-center stat-icon-wrapper d-none d-sm-flex text-success-bg">
                    <fa-duotone-icon icon="circle-check" class="text-success" size="lg" secondaryOpacity="0.5" />
                </div>
                <div class="flex-grow-1 min-w-0">
                    @if (isCardLoading) {
                        <div class="placeholder-glow">
                            <span class="placeholder col-8 placeholder-sm mb-1 d-block"></span>
                            <span class="placeholder col-5 placeholder-lg"></span>
                        </div>
                    } @else {
                        <div class="text-muted small text-uppercase fw-semibold letter-spacing text-truncate">
                            Succeeded Payments
                        </div>
                        <div class="fs-4 fs-md-3 fw-bold">
                            {{ (activeSummary?.totalSuccessfulAmount ?? 0) | CurrencyDisplay: activeCurrency }}
                        </div>
                        <div class="text-muted small">
                            {{ (activeSummary?.successfulPaymentsCount ?? 0) | number }} payments
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>

    <!-- Pending payments -->
    <div class="col-12 col-xl-6">
        <div class="card h-100 stat-card">
            <div class="card-body d-flex align-items-center gap-2 gap-md-3 p-3 p-md-4">
                <div class="rounded-circle d-flex align-items-center justify-content-center stat-icon-wrapper d-none d-sm-flex text-warning-bg">
                    <fa-duotone-icon icon="hourglass-half" class="text-warning" size="lg" secondaryOpacity="0.5" />
                </div>
                <div class="flex-grow-1 min-w-0">
                    @if (isCardLoading) {
                        <div class="placeholder-glow">
                            <span class="placeholder col-8 placeholder-sm mb-1 d-block"></span>
                            <span class="placeholder col-5 placeholder-lg"></span>
                        </div>
                    } @else {
                        <div class="text-muted small text-uppercase fw-semibold letter-spacing text-truncate">
                            Pending Payments
                        </div>
                        <div class="fs-4 fs-md-3 fw-bold">
                            {{ (activeSummary?.totalPendingAmount ?? 0) | CurrencyDisplay: activeCurrency }}
                        </div>
                        <div class="text-muted small">
                            {{ (activeSummary?.pendingPaymentsCount ?? 0) | number }} payments
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
